<template>

    <footer class="footer">

        <div class="footer__container">

            <div class="footer__bloc-links">

                <div class="footer__paragraph">

                    <h3 class="footer__paragraph__title">{{ $t('new_footer_links_title') }}</h3>

                    <a class="footer__paragraph__link" href="/login/email" target="_blank">{{ $t('new_footer_signup') }}</a>
                    <a class="footer__paragraph__link" href="/magic-request-email" target="_blank">{{ $t('new_footer_already_used') }}</a>
                    <a class="footer__paragraph__link" href="/my-data" target="_blank">{{ $t('new_footer_data_use') }}</a>
                    <a class="footer__paragraph__link" href="https://app.adjust.com/uez2im" target="_blank">{{ $t('new_footer_android') }}</a>
                    <a class="footer__paragraph__link" href="https://app.adjust.com/uez2im?deep_link=cleanfox://&redirect=https://itunes.apple.com/fr/app/cleanfox/id1136298377?mt=8" target="_blank">{{
                        $t('new_footer_iOS') }}</a>

                </div>

                <div class="footer__paragraph">

                    <h3 class="footer__paragraph__title">{{ $t('new_footer_title_company') }}</h3>

                    <a class="footer__paragraph__link" href="/foxintelligence" target="_blank">{{ $t('new_footer_about_us') }}</a>
                    <a class="footer__paragraph__link" href="/press" target="_blank">{{ $t('new_footer_press_kit') }}</a>
                    <a class="footer__paragraph__link" href="https://angel.co/company/foxintelligence/jobs" target="_blank">{{ $t('new_footer_jobs') }}</a>

                </div>

                <div class="footer__paragraph">

                    <h3 class="footer__paragraph__title">{{ $t('new_footer_blog_title') }}</h3>

                    <a v-if="isFrench" href="https://cleanfox.io/blog/actualite-fr/" class="footer__paragraph__link" target="_blank">{{ $t('new_footer_news') }}</a>
                    <a v-else href="https://cleanfox.io/blog/cleanfox-news-en/" class="footer__paragraph__link" target="_blank">{{ $t('new_footer_news') }}</a>

                    <a v-if="isFrench" href="https://cleanfox.io/blog/pollution-numerique-fr/" class="footer__paragraph__link" target="_blank">{{ $t('new_footer_pollution')}}</a>
                    <a v-else href="https://cleanfox.io/blog/digital-pollution-en/" class="footer__paragraph__link" target="_blank">{{ $t('new_footer_pollution')}}</a>

                    <a v-if="isFrench" href="https://cleanfox.io/blog/astuces-fr/" class="footer__paragraph__link" target="_blank">{{ $t('new_footer_tips') }}</a>
                    <a v-else href="https://cleanfox.io/blog/tips-en/" class="footer__paragraph__link" target="_blank">{{ $t('new_footer_tips') }}</a>

                </div>

                <div class="footer__paragraph">

                    <h3 class="footer__paragraph__title">{{ $t('new_footer_help_contact_title') }}</h3>

                    <a class="footer__paragraph__link" href="/faq" target="_blank">{{ $t('new_footer_FAQ') }}</a>
                    <a class="footer__paragraph__link" href="mailto:contact@cleanfox.io" target="_blank">{{ $t('new_footer_contact_us') }}</a>

                </div>

            </div>

            <div class="footer__bloc-switch">

                <lang-switch :green="true"></lang-switch>

                <div class="footer__bloc-media" v-if="$mq === 'lg'">
                    <a class="footer__bloc-media__round" href="https://www.facebook.com/cleanfox/" target="_blank">
                        <img src="/img/icons/fg-facebook.svg" class="footer__bloc-media__img">
                    </a>
                    <a class="footer__bloc-media__round" href="https://twitter.com/cleanfoxapp" target="_blank">
                        <img src="/img/icons/fg-twitter.svg" class="footer__bloc-media__img">
                    </a>
                    <a class="footer__bloc-media__round" href="https://www.instagram.com/cleanfox_/" target="_blank">
                        <img src="/img/icons/fg-instagram.svg" class="footer__bloc-media__img">
                    </a>
                    <a class="footer__bloc-media__round" href="https://www.linkedin.com/company/cleanfox/" target="_blank">
                        <img src="/img/icons/fg-linked-in.svg" class="footer__bloc-media__img">
                    </a>
                    <a class="footer__bloc-media__round" href="https://www.youtube.com/channel/UCOTdz6q20jj8rWSiRLFohmw" target="_blank">
                        <img src="/img/icons/fg-youtube.svg" class="footer__bloc-media__img">
                    </a>
                </div>

            </div>

            <div class="footer__dashline"></div>

            <div class="footer__privacy-bloc">

                <div v-if="$mq === 'lg'" class="footer__privacy-bloc__left-side">

                    <p class="footer__bloc-fox__text">{{ $t('new_footer_copyright') }}</p>

                </div>

                <div class="footer__privacy-bloc__rigth-side">

                    <a v-if="isDeutsch" class="footer__paragraph__link desktop-no-mt" href="/impressum" target="_blank">{{ $t('new_footer_impressum') }}</a>

                    <a class="footer__paragraph__link footer__paragraph__link-middle" href="/terms" target="_blank">{{ $t('new_footer_terms_conditions') }}</a>

                    <a class="footer__paragraph__link desktop-no-mt" href="/privacy" target="_blank">{{ $t('new_footer_privacy_policy') }}</a>

                </div>

            </div>

            <div class="footer__bloc-media" v-if="$mq !== 'lg'">
                <a class="footer__bloc-media__round" href="https://www.facebook.com/cleanfox/" target="_blank">
                    <img src="/img/icons/fg-facebook.svg" class="footer__bloc-media__img">
                </a>
                <a class="footer__bloc-media__round" href="https://twitter.com/cleanfoxapp" target="_blank">
                    <img src="/img/icons/fg-twitter.svg" class="footer__bloc-media__img">
                </a>
                <a class="footer__bloc-media__round" href="https://www.instagram.com/cleanfox_/" target="_blank">
                    <img src="/img/icons/fg-instagram.svg" class="footer__bloc-media__img">
                </a>
                <a class="footer__bloc-media__round" href="https://www.linkedin.com/company/cleanfox/" target="_blank">
                    <img src="/img/icons/fg-linked-in.svg" class="footer__bloc-media__img">
                </a>
                <a class="footer__bloc-media__round" href="https://www.youtube.com/channel/UCOTdz6q20jj8rWSiRLFohmw" target="_blank">
                    <img src="/img/icons/fg-youtube.svg" class="footer__bloc-media__img">
                </a>
            </div>

            <div class="footer__bloc-logo">

                <img class="footer__bloc-logo__img" src="/img/logo/large/sand.svg" alt="logo">

            </div>

            <div class="footer__bloc-fox" v-if="$mq !== 'lg'">

                <p class="footer__bloc-fox__text">{{ $t('new_footer_copyright') }}</p>

            </div>

        </div>

    </footer>

</template>

<script>

import I18n from '@/modules/i18n'

import LangSwitch from '@/components/LangSwitch'

export default {

    name: 'footer-green',

    components: {LangSwitch},

    computed: {

        isDeutsch() {
            return I18n.get(this) === 'de'
        },

        isFrench() {
            return I18n.get(this) === 'fr'
        }
    },

    data() {
        return {
            year: new Date().getFullYear()
        }
    }

}

</script>

<style scoped lang="scss">

    .footer {
        padding: 8px 16px 32px;
        background-color: $rifle;
        display: flex;
        flex-direction: column;
        color: $sand;
        @media screen and (min-width: $above-tablet-length) {
            width: 100%;
            align-items: center;
            padding-top: 40px;
        }

        &__container {
            @media screen and (min-width: $above-tablet-length) {
                width: 100%;
                max-width: 860px;
                margin: 0 32px;
            }
        }

        &__bloc-links {
            @media screen and (min-width: $above-tablet-length) {
                display: flex;
                flex-direction: row;
                justify-content: space-between;
            }
        }

        &__paragraph {
            display: flex;
            flex-direction: column;
            align-items: flex-start;

            &__title {
                font-size: 17px;
                font-weight: bold;
                line-height: 1.3;
                margin-top: 24px;
            }

            &__link {
                font-size: 14px;
                line-height: 1.43;
                margin-top: 8px;
                color: $sand;
            }

            &__link-middle {
                @media screen and (min-width: $above-tablet-length) {
                    margin: 0 16px;
                }
            }
        }

        &__bloc-switch {
            margin-top: 32px;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
        }

        &__dashline {
            margin-top: 32px;
            width: 100%;
            height: 1px;
            opacity: 0.16;
            border-radius: 8px;
            background-color: $white;
            @media screen and (min-width: $above-tablet-length) {
                margin-top: 14px;
            }
        }

        &__privacy-bloc {
            margin-top: 32px;
            @media screen and (min-width: $above-tablet-length) {
                flex-direction: row;
                display: flex;
                justify-content: space-between;
                margin-top: 10px;
            }

            &__rigth-side {
                display: flex;
                flex-direction: column;
                @media screen and (min-width: $above-tablet-length) {
                    flex-direction: row;
                }
            }

            &__left-side {

            }

        }

        &__bloc-media {
            margin-top: 32px;
            display: flex;
            flex-direction: row-reverse;
            justify-content: center;

            &__round {
                width: 32px;
                height: 32px;
                border-radius: 24px;
                background-color: $forest;
                display: flex;
                align-items: center;
                justify-content: center;
                margin: 0 4px;
                cursor: pointer;
            }

            &__img {
                width: 12px;
                object-fit: contain;
            }
        }

        &__bloc-logo {
            margin-top: 48px;

            &__img {
                width: 100%;
                max-width: 170px;
                object-fit: contain;
                margin: 0 16px;
            }
        }

        &__bloc-fox {
            margin-top: 24px;

            &__text {
                font-size: 14px;
                line-height: 1.29;
            }
        }
    }

    .desktop-no-mt {
        @media screen and (min-width: $above-tablet-length) {
            margin-top: 0;
        }
    }


</style>
